import { useForm } from "react-hook-form";
import { Col, FormGroup, Label, Row, Spinner } from "reactstrap";
import MonacoEditor from "../../components/MonacoEditor/MonacoEditor";
import { styleTypes } from "../../enums/styleTypes";
import { connect } from "react-redux";
import ButtonCustom from "../../components/Buttons/ButtomCustom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import useQueryParams from "../../customHooks/useQueryParams";
import { useEffect, useRef } from "react";
import { fieldsMessage } from "../../helpers/utils/fieldsMessage";
import {
  cleanMessageStyle,
  disableLoadingStyle,
  getStyle,
  getStyleHistory,
  loadEmptyStyle,
  saveStyle,
} from "../../store/actions";
import { setValuesHookForm } from "../../helpers/load_object_hook_form";
import { useNavigate } from "react-router-dom";
import { useContextActions } from "../../customHooks/useContextActions";
import ActionButtons from "../../components/ActionButtons/ActionButtons";
import useAlert from "../../customHooks/useAlert";

const GenericStyleDetail = ({
  loadingStyle,
  style,
  isStyleSave,
  messageStyle,
  loadEmptyStyle,
  cleanMessageStyle,
  disableLoadingStyle,
  getStyleRequest,
  getStyleHistoryRequest,
  saveStyleRequest,
  type,
  errorLoadingStyle,
  errorLoadingStyleHistory,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      active: true,
    }
  });
  const alertModal = withReactContent(Swal);
  const { confirmAlert } = useAlert();
  
  const navigate = useNavigate();
  const params = useQueryParams();
  const id = params.get("id");
  const idHistory = params.get("idHistory");
  const hasInteracted = useRef(false);
  const initialContentRef = useRef(null);
  const hasInitializedContent = useRef(false);
  
  function handleBack() {
    loadEmptyStyle();
    if (type === styleTypes.TABLE) {
      navigate("/table-styles");
    } else if (type === styleTypes.LIST) {
      navigate("/list-styles");
    } else if (type === styleTypes.TEXT) {
      navigate("/text-styles");
    }
  }
  async function handleSave(values) {
    const isEdit = id !== null;
    const baseBody = {
      title: values.title,
      active: values.active,
      description: values.description,
      content: values.content,
      className: values.className,
      type: type,
    }
    const body = isEdit ? { ...baseBody, id } : baseBody;

    if(isEdit) {
      const result = await confirmAlert(`Attention! All documents associated with this ${type} Style will be updated to Draft status. Do you want to continue?`)

        if(!result.isConfirmed) return;
    }

    await saveStyleRequest({ 
      body, 
      method: isEdit ? "PUT" : "POST" 
    });
  }

  const actions = useContextActions({
    context: "style",
    screen: "detail",
  })
  const editableWithSave = actions.some(e => e === 'save')

  useEffect(() => {
    if (id !== null) {
      getStyleRequest({ styleId: id });
    } else if (idHistory !== null) {
      getStyleHistoryRequest({ idHistory: idHistory });
    } else {
      disableLoadingStyle();
    }

    return () => {
      loadEmptyStyle();
      cleanMessageStyle();
    };
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (isStyleSave !== null) {
      alertModal
        .fire({
          title:
            isStyleSave === true
              ? `Style ${id === null ? "created" : "updated"} successfully!`
              : `${
                  messageStyle !== null
                    ? messageStyle
                    : "Something wrong, try again later."
                }`,
          icon: isStyleSave === true ? "success" : "error",
          showConfirmButton: false,
          showCloseButton: true,
          timer: isStyleSave === true ? 2000 : undefined,
          timerProgressBar: isStyleSave === true ? true : false,
        })
        .then((result) => {
          if (isStyleSave) {
            if (result.dismiss) {
              cleanMessageStyle();
              if (type === styleTypes.TABLE) {
                navigate("/table-styles");
              } else if (type === styleTypes.LIST) {
                navigate("/list-styles");
              } else if (type === styleTypes.TEXT) {
                navigate("/text-styles");
              }
            }
          }

          if (result.dismiss) {
            cleanMessageStyle();
          }
        });
    }

    // eslint-disable-next-line
  }, [isStyleSave]);
  useEffect(() => {
    if (errorLoadingStyle !== null) {
      alertModal
        .fire({
          title: "Something wrong, try again later.",
          icon: "error",
          showConfirmButton: false,
          showCloseButton: true,
          allowOutsideClick: false,
          //timer: 2000,
          //timerProgressBar: true,
        })
        .then((result) => {
          if (errorLoadingStyle) {
            if (result.dismiss) {
              cleanMessageStyle();
              loadEmptyStyle();
              if (type === styleTypes.TABLE) {
                navigate("/table-styles");
              } else if (type === styleTypes.LIST) {
                navigate("/list-styles");
              } else if (type === styleTypes.TEXT) {
                navigate("/text-styles");
              }
            }
          }
          if (result.dismiss) {
            cleanMessageStyle();
            loadEmptyStyle();
          }
        });
    }

    // eslint-disable-next-line
  }, [errorLoadingStyle]);
  useEffect(() => {
    if (errorLoadingStyleHistory !== null) {
      alertModal
        .fire({
          title: "Something wrong, try again later.",
          icon: "error",
          showConfirmButton: false,
          showCloseButton: true,
          allowOutsideClick: false,
          //timer: 2000,
          //timerProgressBar: true,
        })
        .then((result) => {
          if (errorLoadingStyleHistory) {
            if (result.dismiss) {
              cleanMessageStyle();
              loadEmptyStyle();
              if (type === styleTypes.TABLE) {
                navigate("/table-styles");
              } else if (type === styleTypes.LIST) {
                navigate("/list-styles");
              } else if (type === styleTypes.TEXT) {
                navigate("/text-styles");
              }
            }
          }
          if (result.dismiss) {
            cleanMessageStyle();
            loadEmptyStyle();
          }
        });
    }

    // eslint-disable-next-line
  }, [errorLoadingStyleHistory]);
  useEffect(() => {
    if (!style) return;

    setValuesHookForm(style, setValue);
    setValue("active", style.active ?? true);

    if (!hasInitializedContent.current) {
      const initial = style.content ?? "";
      setValue("content", initial);
      initialContentRef.current = initial;
      hasInitializedContent.current = true;
    }
    // eslint-disable-next-line
  }, [style]);
  useEffect(() => {
    register("content", {
      required: "Content is required.",
      validate: (value) => {
        if (!value) return fieldsMessage.required("Content");
        if (value.trim() === "") return fieldsMessage.required("Content");
        return true;
      },
    });
  }, [register]);

  return (
    <>
      {loadingStyle ? (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "400px", width: "100%" }}
        >
          <Spinner color="primary" style={{ height: "5rem", width: "5rem" }} />
        </div>
      ) : (
        <>
          <form onSubmit={handleSubmit(handleSave)}>
            <div className="d-flex justify-content-between my-2">
              <h2>
                {id === null
                  ? idHistory === null
                    ? "CREATE"
                    : "VIEW"
                  : "EDIT"}{" "}
                {type === styleTypes.TABLE
                  ? "TABLE"
                  : type === styleTypes.LIST
                    ? "LIST"
                    : type === styleTypes.TEXT
                      ? "TEXT"
                      : ""}{" "}
                STYLE
              </h2>
              <div className="d-flex gap-2 mb-4">
                <ButtonCustom type="cancel" onClick={() => handleBack()} />
                <ActionButtons 
                  actions={actions}
                  handlers={{
                    save: handleSubmit(handleSave)
                  }}
                />
              </div>
            </div>

            <Row>
              <Col md="4">
                <FormGroup className="mb-3">
                  <Label htmlFor="title" className="label-detail-form">
                    Title
                  </Label>
                  <input
                    className="form-control"
                    id="title"
                    type="text"
                    disabled={(idHistory !== null) || (!editableWithSave)}
                    style={(idHistory !== null) || (!editableWithSave) ? {color: "#00000060"} : {}}
                    placeholder="Style title"
                    {...register("title", {
                      required: fieldsMessage.required("Style title"),
                      validate: (value) =>
                        value.trim() !== "" ||
                        fieldsMessage.required("Style title"),
                      maxLength: {
                        value: 100,
                        message: fieldsMessage.maxLength("Style title", 100),
                      },
                    })}
                  />
                  <p className="error-form">{errors.title?.message}</p>
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup className="mb-3">
                  <Label htmlFor="title" className="label-detail-form">
                    Description
                  </Label>
                  <input
                    className="form-control"
                    id="description"
                    type="text"
                    disabled={(idHistory !== null) || (!editableWithSave)}
										style={(idHistory !== null) || (!editableWithSave) ? {color: "#00000060"} : {}}
                    placeholder="Style description"
                    {...register("description")}
                  />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup className="mb-3">
                  <Label htmlFor="className" className="label-detail-form">
                    Class Name
                  </Label>
                  <input
                    className="form-control"
                    id="className"
                    type="text"
                    disabled={(idHistory !== null) || (!editableWithSave)}
										style={(idHistory !== null) || (!editableWithSave) ? {color: "#00000060"} : {}}
                    placeholder="Style Class Name"
                    {...register("className", {
                      required: fieldsMessage.required("Style class"),
                      validate: (value) =>
                        value.trim() !== "" ||
                        fieldsMessage.required("Style class"),
                      maxLength: {
                        value: 100,
                        message: fieldsMessage.maxLength("Style class", 100),
                      },
                    })}
                  />
                  <p className="error-form">{errors.className?.message}</p>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md="3">
                <FormGroup className="mb-3">
                  <Label htmlFor="createUser" className="label-detail-form">
                    Created By
                  </Label>
                  <input
                    className="form-control"
                    id="createUser"
                    {...register("createUser")}
                    disabled
                    style={{ color: '#00000060'}}
                  />
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup className="mb-3">
                  <Label id="createDate" className="label-detail-form">
                    Creation Date
                  </Label>
                  <input
                    className="form-control"
                    name="createDate"
                    {...register("createDate")}
                    disabled
                    style={{ color: '#00000060'}}
                  />
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup className="mb-3">
                  <Label id="updateUser" className="label-detail-form">
                    Updated By
                  </Label>
                  <input
                    className="form-control"
                    name="updateUser"
                    {...register("updateUser")}
                    disabled
                    style={{ color: '#00000060'}}
                  />
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup className="mb-3">
                  <Label id="updateDate" className="label-detail-form">
                    Update Date
                  </Label>
                  <input
                    className="form-control"
                    name="updateDate"
                    {...register("updateDate")}
                    disabled
                    style={{ color: '#00000060'}}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row className="my-2 mb-4">
              <Col className="d-flex align-items-center">
                <FormGroup>
                  <label htmlFor="active" className="label-check">
                    <input
                      id="active"
                      type="checkbox"
                      className="form-check-input"
                      disabled={(idHistory !== null) || (!editableWithSave)}
                      {...register("active")}
                    />
                    Active Status
                  </label>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <FormGroup className="mb-3">
                  <Label htmlFor="content" className="label-detail-form">
                    Content
                    <span className="error-form">
                      {" "}
                      {errors.content?.message}
                    </span>
                  </Label>
                  <MonacoEditor
                    handleEditorChange={(content) => {
                      initialContentRef.current = content;
                      setValue("content", content, {
                        shouldValidate: hasInteracted.current,
                        shouldDirty: true,
                      });
                      if (!hasInteracted.current) {
                        hasInteracted.current = true;
                      }
                    }}
                    language="css"
                    initialValue={hasInteracted.current ? initialContentRef.current ?? "" : (style?.content ?? "")}
                    loading={loadingStyle}
                    isEditable={(idHistory !== null) || (!editableWithSave)}
                  />
                </FormGroup>
              </Col>
            </Row>
            <div className="d-flex justify-content-end my-4 gap-2">
                <ButtonCustom type="cancel" onClick={() => handleBack()} />
                <ActionButtons 
                  actions={actions}
                  handlers={{
                    save: handleSubmit(handleSave)
                  }}
                />
            </div>
          </form>
        </>
      )}
    </>
  );
};

const mapStateToProps = ({
  StyleReducer: {
    loadingStyle,
    style,
    isStyleSave,
    messageStyle,
    errorLoadingStyle,
    errorLoadingStyleHistory,
  },
}) => {
  return {
    loadingStyle,
    style,
    isStyleSave,
    messageStyle,
    errorLoadingStyle,
    errorLoadingStyleHistory,
  };
};

const mapDispatchToProps = {
  loadEmptyStyle,
  cleanMessageStyle,
  disableLoadingStyle,
  getStyleRequest: getStyle.request,
  getStyleHistoryRequest: getStyleHistory.request,
  saveStyleRequest: saveStyle.request,
};
export default connect(mapStateToProps, mapDispatchToProps)(GenericStyleDetail);
